import React from 'react';
import { useTranslation } from 'react-i18next';
import { getStrategyHudTotal } from '../../utils/strategyHudTotal';
import { MOBILE_OPPONENT_STATS_TOP_PX } from './mobileBattleLayoutOffsets';
import './MobileOpponentStats.css';

/**
 * Mobile Opponent Stats (O:, S:, C:) — upper-right, below opponent drone strip.
 * Mirrors desktop `opponent-stats-counters` in BattleUI.
 */
export const MobileOpponentStats = ({ opponent }) => {
  const { t } = useTranslation();

  return (
    <div
      className="opponent-stats-counters-mobile"
      style={{ '--mobile-opponent-stats-top': `${MOBILE_OPPONENT_STATS_TOP_PX}px` }}
    >
      <div className="opponent-stats-counters-mobile__item">
        <span
          className="opponent-stats-counters-mobile__label"
          data-tooltip={t('battleUI.ordersReady')}
        >
          O:
        </span>
        <span>{opponent?.hand?.length ?? 0}</span>
      </div>
      <div className="opponent-stats-counters-mobile__item">
        <span
          className="opponent-stats-counters-mobile__label"
          data-tooltip={t('battleUI.strategySize')}
        >
          S:
        </span>
        <span>{getStrategyHudTotal(opponent)}</span>
      </div>
      <div className="opponent-stats-counters-mobile__item">
        <span
          className="opponent-stats-counters-mobile__label"
          data-tooltip={t('battleUI.completedOrders')}
        >
          C:
        </span>
        <span>{opponent?.completedOrders?.length ?? 0}</span>
      </div>
    </div>
  );
};

export default MobileOpponentStats;
